export default {"src":"/_next/static/image/public/images/ic_envelope.1cb1a2aca565784d143df32606656680.svg","height":32,"width":32};